import { axios, baseURL } from "./axios.dashboard"

const Br_Report = async (branchCode, seq_Id = 999) => {
    return await axios
        .post( baseURL+"reports/BR_REPORT_LIST", {
            branchCode: branchCode,
            seq_Id : seq_Id
        })
        .then((response) => {
            return response
        }).catch((e) => {
            return e.response.data
        })
}

export { Br_Report }